document.addEventListener('DOMContentLoaded', function () {
  const footerCopyright = document.querySelector('.footer__copyright');
  if (!footerCopyright) return;

  const existingCredit = footerCopyright.querySelector('[data-lirogo-credit], a[href*="lirogo.com"]');
  if (existingCredit) return;

  const credit = document.createElement('small');
  credit.className = 'copyright__content footer-lirogo-credit';
  credit.setAttribute('data-lirogo-credit', '');
  credit.appendChild(document.createTextNode('Desarrollado por '));

  const link = document.createElement('a');
  link.href = 'https://lirogo.com/shopify';
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.textContent = 'Agencia Lirogo Digital';
  credit.appendChild(link);

  const policies = footerCopyright.querySelector('.policies');
  if (policies) footerCopyright.insertBefore(credit, policies);
  else footerCopyright.appendChild(credit);
});
